<template>
	<div class="facebookUpload">
		<el-upload
			action
			:show-file-list="false"
			:http-request="uploadSectionFile"
			:before-upload="beforeAvatarUpload"
			:accept="accept"
			:disabled="disabled"
		>
			<slot></slot>
		</el-upload>
	</div>
</template>

<script>
import uploadService from 'sky-ossupload';
import skyRequest from 'skytech-request';
import OSS from 'ali-oss';
import { getDomain } from 'sky-domain';
import md5 from 'md5';

export default {
	name: 'facebookUpload',
	props: ['accept', 'list', 'type', 'disabled', 'start', 'end', 'isBefore'],
	methods: {
		conversion(name) {
			return (
				name.slice(0, name.lastIndexOf('.') + 1) +
				name.slice(name.lastIndexOf('.') + 1).toLowerCase()
			);
		},
		async uploadSectionFile(param) {
			try {
				// 初始化OSS配置
				const oss = uploadService({
					request: skyRequest,
					getHost: getDomain,
					platform: 'iglobalwin-pub-oss',
					OSS,
				});

				// 处理文件名和类型
				const originalFileName = this.conversion(param.file.name);
				const fileExtension = originalFileName
					.slice(originalFileName.lastIndexOf('.') + 1)
					.toLowerCase();
				const ossFileName = `${md5(`${new Date().getTime() + originalFileName}`)}.${fileExtension}`;

				// 获取OSS客户端实例
				const ossClient = await oss.ossConfig({ OSS });

				// 查找或创建文件上传状态记录
				let fileItemIndex = this.list.findIndex(item => item.ossName === ossFileName);
				const newFileItem = {
					fileName: originalFileName,
					filetype: fileExtension,
					type: this.type,
					ossName: ossFileName,
					client: ossClient,
					url: '',
					percentage: 0,
					// 上传状态 0:未上传 1:上传中 2:成功 3:失败
					status: 1, // 立即标记为上传中
					size: param.file.size,
				};

				// 更新或添加文件项
				if (fileItemIndex >= 0) {
					this.list[fileItemIndex] = newFileItem;
				} else {
					this.list.push(newFileItem);
					fileItemIndex = this.list.length - 1;
				}

				// 通知开始上传并触发事件
				this.start();
				this.$emit('upload', this.list);

				// 执行分片上传
				const uploadResult = await ossClient.multipartUpload(ossFileName, param.file, {
					progress: (progress, checkpoint, response) => {
						// 更新上传进度
						const currentProgress = Math.round(progress * 100);
						if (fileItemIndex >= 0 && this.list[fileItemIndex]) {
							this.list[fileItemIndex].percentage = currentProgress;
							this.list[fileItemIndex].status = 1; // 确保状态为上传中
						}

						// 上传完成时标记状态
						if (progress === 1) {
							this.list[fileItemIndex].response = response; // 保存完整response
							this.end();
						}

						this.$emit('upload', this.list);
					},
				});

				// 上传成功，更新URL和状态
				if (fileItemIndex >= 0 && this.list[fileItemIndex]) {
					const uploadResponse = this.list[fileItemIndex].response;
					// 1. 先提取requestUrls的第一项
					let rawUrl = uploadResponse?.requestUrls?.[0];

					let url = rawUrl.indexOf('?') > -1 ? rawUrl.slice(0, rawUrl.indexOf('?')) : rawUrl;

					this.list[fileItemIndex].url = url;
					this.list[fileItemIndex].status = 2; // 标记为成功
					this.$emit('upload', this.list);
				}

				return uploadResult;
			} catch (error) {
				console.error('文件上传失败:', error);

				// 查找并标记错误状态
				const errorItemIndex = this.list.findIndex(item => item.ossName === ossFileName);
				if (errorItemIndex >= 0 && this.list[errorItemIndex]) {
					this.list[errorItemIndex].status = 3; // 标记为失败
					this.$emit('upload', this.list);
				}

				// 可以在这里添加错误处理逻辑，如重试机制等
				throw error; // 重新抛出错误，让调用方可以处理
			}
		},
		beforeAvatarUpload(file) {
			const isLt2M = file.size / 1024 / 1024 <= 60;
			if (!this.isBefore) return true;
			if (!isLt2M && this.type == 'video') {
				this.$alert('视频大小不得超过60MB', '提示', {
					confirmButtonText: '确定',
				});
				return false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.facebookUpload {
	::v-deep .el-upload {
		width: 100%;

		.dropdown-text {
			text-align: left;
		}
	}
}
</style>
